export default __webpack_public_path__ + "static/media/04.36d8f66a.png";